
import arMessages from '../locales/ar-AR';

const ArLang = {
    messages: {
        ...arMessages
    },
    locale: 'ar-AR',
 
};
export default ArLang;